// Configuración legal centralizada de Asset Passport.
// ANTES DEL LANZAMIENTO COMERCIAL:
//   - Completar LEGAL_IDENTITY.nif y LEGAL_IDENTITY.address (obligatorio, Ley 34/2002 LSSI).
//   - Configurar REACT_APP_LEGAL_EMAIL (p. ej. privacy@assetpassport.io / support@assetpassport.io).
// Mientras no existan, las páginas legales OMITEN esos campos (no se muestran placeholders falsos).

export const LEGAL_LAST_UPDATED = "9 de septiembre de 2026";

export const LEGAL_VERSIONS = {
  legalNotice: "legal-notice-2026-09-09",
  privacy: "privacy-2026-09-09",
  terms: "terms-b2b-2026-09-09",
  cookies: "cookies-2026-09-09",
  dpa: "dpa-2026-09-09",
};

export const LEGAL_IDENTITY = {
  ownerName: "Roberto Feltrer Valero",
  commercialName: "Asset Passport",
  country: "España",
  nif: null, // PENDIENTE DE CONFIGURACIÓN antes del lanzamiento comercial
  address: null, // PENDIENTE DE CONFIGURACIÓN antes del lanzamiento comercial
};

export const LEGAL_EMAIL = process.env.REACT_APP_LEGAL_EMAIL || null;
